import _ from "lodash";

import IColumn from "models/IColumn";
import { getTranslation } from "helpers/common";
import { ROLE_IDS } from "constants/.";

export const columnsExcel: IColumn[] = [
  {
    title: "ORDERS_DATE",
    key: "Date",
    type: "date"
  },
  {
    title: "ORDERS_STATE",
    key: "StateId",
    render: ({ StateId }) =>
      StateId === "Vervallen" ? getTranslation("YES") : getTranslation("NO")
  },
  {
    title: "ORDERS_TYPE",
    key: "TypeId"
  },
  {
    title: "ORDERS_NUMBER",
    key: "Number"
  },
  {
    title: "PURCHASE_TYPE",
    key: "RoleId"
  },
  {
    title: "COUNTERPARTY_COMPANY",
    key: "OtherRelation.Name",
    width: 25
  },
  {
    title: "BUYER_REPS",
    key: "BuyerAgent.Name"
  },
  {
    title: "SELLER_COMPANY",
    key: "SellerAgent.Name"
  },
  {
    title: "PREFERRED_GROWER_COMPANY",
    key: "Supplier.Name"
  },
  {
    title: "GROWER_COMPANY",
    key: "Seller.Name",
    render: rowData =>
      ROLE_IDS[rowData.RoleId] === "Supplier"
        ? _.get(rowData, "Seller.Name", "-")
        : "-"
  },
  {
    title: "ORDERS_FROM_DATE",
    key: "DeliveryPeriodStart",
    type: "date"
  },
  {
    title: "DELIVERIES_TILL_DATE",
    key: "DeliveryPeriodEnd",
    type: "date"
  },
  {
    title: "ORDERS_SCHEME",
    key: "InCoverScheme",
    type: "boolean"
  },
  {
    title: "PAYMENT_DATE",
    key: "PaymentDate",
    type: "date"
  },
  {
    title: "ORDERS_PAYMENT",
    key: "AdvancePayment",
    type: "boolean"
  },
  {
    title: "HARVEST_YEAR",
    key: "HarvestYear"
  },
  {
    title: "LINE_NR",
    key: "Lines[index].Number",
    isArray: true
  },
  {
    title: "PRODUCT_GROUP",
    key:
      "Lines[index].Item.ProductType.ProductGroup.ProductCategory.Description",
    isArray: true
  },
  {
    title: "DELIVERIES_GENUS",
    key: "Lines[index].Item.ProductType.ProductGroup.Description",
    isArray: true
  },
  {
    title: "KIND",
    key: "Lines[index].Item.ProductType.Description",
    isArray: true
  },
  {
    title: "DELIVERIES_CULTIVAR",
    key: "Lines[index].Item.CultivarDescription",
    isArray: true
  },
  {
    title: "ARTICLE_DESCRIPTION",
    key: "Lines[index].Item.Description/Lines[index].GrowerClaims",
    isArray: true,
    render: (rowData, col, index) => {
      const keys = col.key.split("/");
      return (
        _.get(rowData, _.replace(keys[0], "index", index), "") +
        _.get(rowData, _.replace(keys[1], "index", index), "")
      );
    },
    width: 30
  },
  {
    title: "SIZE_NR",
    key: "Lines[index].ProductValue1.Description",
    isArray: true,
    customData: {
      number: "1"
    }
  },
  {
    title: "SIZE_NR",
    key: "Lines[index].ProductValue2.Description",
    isArray: true,
    customData: {
      number: "2"
    }
  },
  {
    title: "SIZE_NR",
    key: "Lines[index].ProductValue3.Description",
    isArray: true,
    customData: {
      number: "3"
    }
  },
  {
    title: "PRICE",
    key: "Lines[index].Price",
    render: (rowData, col, index) => {
      const value = _.get(rowData, _.replace(col.key, "index", index));
      return value && ROLE_IDS[rowData.RoleId] !== "Supplier" ? value : 0;
    },
    type: "currency",
    isArray: true
  },
  {
    title: "PRICE_UNIT",
    key: "Lines[index].PriceUnit.Description",
    render: (rowData, col, index) =>
      ROLE_IDS[rowData.RoleId] !== "Supplier"
        ? _.get(rowData, _.replace(col.key, "index", index), "-")
        : "-",
    isArray: true
  },
  {
    title: "QUANTITY",
    key: "Lines[index].Quantity",
    type: "number",
    isArray: true
  },
  {
    title: "QUANTITY_UNIT",
    key: "Lines[index].QuantityUnit.Description",
    isArray: true
  },
  {
    title: "DELIVERIED_QUANTITY",
    key: "Lines[index].ShippedQuantity",
    type: "number",
    isArray: true
  },
  {
    title: "DELIVERIES_COMPLETE",
    key: "Lines[index].ShippedCompletely",
    type: "boolean",
    isArray: true
  },
  {
    title: "ORDERS_EX_BTW",
    key: "Lines[index].OrderedAmount",
    render: (rowData, col, index) => {
      const value = _.get(rowData, _.replace(col.key, "index", index));
      return value && ROLE_IDS[rowData.RoleId] !== "Supplier" ? value : 0;
    },
    type: "currency",
    isArray: true
  },
  {
    title: "EXTERNAL_NR",
    key: "ExternalReferenceNumber"
  },
  {
    title: "DELIVERIES_BIO",
    key: "Lines[index].Bio",
    type: "boolean",
    isArray: true
  }
];
